import { EmailAccountModel } from "@jugl-web/rest-api";
import { createContext } from "react";

export interface EmailAccountContextType {
  emailAccount: EmailAccountModel | undefined;
  isConnected: boolean;
  isEmailConfigLoading: boolean;
  connectEmailAccount: () => void;
  disconnectEmailAccount: () => Promise<void>;
  isDisconnectingEmailAccount: boolean;
  refetchEmailConfig: () => void;
}

export const EmailAccountContext =
  createContext<EmailAccountContextType | null>(null);
